<div class="flex column border radius">
  <div class="flex center between bg-light-grey padding-small radius radius-bottom-none m-column m-start">
    <div class="flex column">
      <span class="small grey uppercase">{{ productPath }}</span>
      <b class="primary-dark">{{ product.style.code }} - {{ product.style.name }}</b>
    </div>

    <div class="flex center m-full-width m-margin-top-small">
      <span class="flex center red hover margin-right" (click)="removeProduct.emit(product)">
        <i class="fa-solid fa-xmark small margin-right-smallest"></i>
        Remove product
      </span>

      <i
        class="fa-solid {{ product.opened ? 'fa-chevron-up' : 'fa-chevron-down' }} hover"
        (click)="toggleProduct.emit(product)"
      ></i>
    </div>
  </div>

  @if (product.opened) {
    @for (color of product.colors; track color.color.id) {
      <div class="padding">
        <div class="flex center between m-column m-start">
          <span class="bg-light-grey border primary bold padding-left-smallest padding-right-smallest radius">
            {{ color.color.code }} {{ color.color.name || '-' }}
          </span>

          <div class="flex center gap m-full-width m-margin-top-small">
            @if (color.isAi) {
              <span class="flex center bg-orange primary padding-left-smallest padding-right-smallest border radius">
                <i class="fa-solid fa-robot small margin-right-smallest"></i>
                AI generated
              </span>
            }

            <span
              class="flex center primary hover desktop-only {{ getShotsWithImages(color).length ? '' : 'disabled' }}"
              (click)="onOpenGallery(color)"
            >
              <i class="fa-solid fa-expand small margin-right-smallest"></i>
              View as gallery
            </span>

            <span class="flex center red hover margin-left-small" (click)="removeColor.emit(color.color)">
              <i class="fa-solid fa-xmark small margin-right-smallest"></i>
              Remove color
            </span>
          </div>
        </div>

        @if (getShotsWithImages(color).length) {
        <div class="shot-grid margin-top-small">
          @for (shot of getShotsWithImages(color); track shot.id) {
            <div class="flex column border radius">
              <div class="relative hover" (click)="onOpenGallery(color, shot.id)">
                <img class="shot-preview" [src]="shot.imgPath" alt="Shot preview" loading="lazy" />
                @if (isVideo(shot)) {
                  <i class="fa-solid fa-circle-play white video-play-icon"></i>
                }
              </div>

              <div class="flex column padding-small">
                <div class="flex center between">
                  <b class="truncate">{{ shot.shotType?.name }}</b>
                  @if (shot.isAi) {
                    <i class="fa-solid fa-robot small orange" matTooltip="AI generated"></i>
                  }
                </div>
                <span class="small grey">
                  {{ shot.aspectRatio?.id == 1 ? 'Square' : '-' }} {{ shot.aspectRatio?.label }}, {{ shot.mediaFormat?.name }}
                </span>
              </div>
            </div>
          }
        </div>
        } @else {
          <div class="bg-light-grey padding-small margin-top-small radius flex center grey">No photos for this color</div>
        }
      </div>
    }
  }
</div>
